import { Typography } from "@mui/material";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

const TermsAndConditions = () => {
  return (
    <Typography textAlign="center">
      <Trans i18nKey="signup.terms">
        By signing up with email, Google, or Apple, you agree to our{" "}
        <Link to="https://www.holavida.com/terms-conditions" target="_blank">
          Terms & Conditions
        </Link>{" "}
        and acknowledge our{" "}
        <Link to="https://www.holavida.com/privacy-policy" target="_blank">
          Privacy Policy
        </Link>
        .
      </Trans>
    </Typography>
  );
};

export default TermsAndConditions;
